<div class="empty">
    @if (src) {
        <img style="max-width: 20%" [attr.src]="src" />
    }
    <h2 class="centered">{{ label | appTranslate }}</h2>
</div>
